import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Youtube, Mail, MapPin } from 'lucide-react';
import { CATEGORIES, MICHIGAN_CITIES } from '../mock/mock';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-16 text-[#cdeddb]" style={{ background: 'linear-gradient(180deg, #0f5132 0%, #0b3d26 100%)' }}>
      <div className="max-w-[1320px] mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <span className="inline-flex items-center justify-center w-11 h-11 rounded-lg bg-white p-1">
                <img src="/tmb-logo.png" alt="TMB Global News" className="w-full h-full object-contain" />
              </span>
              <span className="font-display font-extrabold text-xl text-white">TMB Global News</span>
            </div>
            <p className="text-sm leading-relaxed text-[#a9d4bd] max-w-xs">
              Michigan’s trusted news network — bringing you the latest local headlines, politics, sport, financials and fashion, locally and globally.
            </p>
            <div className="flex items-center gap-3 mt-5">
              {[Facebook, Twitter, Instagram, Youtube].map((Icon, i) => (
                <a key={i} href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#157347] flex items-center justify-center transition-colors" aria-label="social">
                  <Icon className="w-4 h-4 text-white" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-cond font-bold uppercase tracking-wider text-white text-sm mb-4">Sections</h4>
            <ul className="space-y-2.5 text-sm">
              {CATEGORIES.map((c) => (
                <li key={c.slug}>
                  <Link to={`/category/${c.slug}`} className="hover:text-white transition-colors">{c.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-cond font-bold uppercase tracking-wider text-white text-sm mb-4">Michigan Coverage</h4>
            <ul className="space-y-2.5 text-sm">
              {MICHIGAN_CITIES.slice(0, 6).map((c) => (
                <li key={c} className="inline-flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5 text-[#8be0b0]" />{c}</li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-cond font-bold uppercase tracking-wider text-white text-sm mb-4">Advertise &amp; Contact</h4>
            <p className="text-sm text-[#a9d4bd] mb-4">Reach over 5 million readers locally and globally. Get your brand in front of Michigan.</p>
            <Link to="/contact" className="inline-flex items-center gap-2 bg-[#2fbf71] hover:bg-[#2e9e6b] text-[#0b3d26] font-semibold text-sm px-4 py-2.5 rounded-md transition-colors">
              <Mail className="w-4 h-4" /> Contact Sales
            </Link>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1320px] mx-auto px-4 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#a9d4bd]">
          <span>© {year} TMB Global News. All rights reserved.</span>
          <div className="flex items-center gap-4">
            <Link to="/terms" className="hover:text-white transition-colors">Terms &amp; Conditions</Link>
            <span className="text-white/25">|</span>
            <span>Updated twice daily · Made in Michigan</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
